import { API_URL_SUMMARY_LAMBDAS } from '../config/Environment';
import { getOrCreateApiSessionsServer } from './apiSessions'; // oxlint-disable-line import/no-cycle -- Pre-existing dependency cycle, grandfathered during the oxlint migration.
import { createAxiosInstance, getErrorHandler, getSuccessHandler, type WithAxiosServer } from './createAxiosInstance'; // oxlint-disable-line import/no-cycle -- Pre-existing dependency cycle, grandfathered during the oxlint migration.

import type { LogLevel } from '../utils/logger';
import type { AxiosInstance } from 'axios';

class ApiTraceServer implements WithAxiosServer {
	server: AxiosInstance;

	constructor() {
		this.server = createAxiosInstance(API_URL_SUMMARY_LAMBDAS);
	}

	log = async (logLevel: LogLevel, message: any, username: string, extras: any = {}) => {
		const body = JSON.stringify({ message, extras, username, logLevel });
		return this.server.post('log', body, {
			headers: { 'content-type': 'application/json' },
		});
	};

	logError = async (eventType: string, error: any, info: any) => {
		const body = JSON.stringify({ event_type: eventType, error, info });
		return this.server.post('log', body, {
			headers: { 'content-type': 'application/json' },
		});
	};
}

let maybeApiTraceServer: ApiTraceServer | null = null;

function createApiTraceServer(): ApiTraceServer {
	const apiTraceServer = new ApiTraceServer();

	apiTraceServer.server.interceptors.response.use(
		getSuccessHandler(),
		getErrorHandler(apiTraceServer.server, getOrCreateApiSessionsServer()),
	);

	return apiTraceServer;
}

export function getOrCreateApiTraceServer(): ApiTraceServer {
	if (maybeApiTraceServer === null) {
		maybeApiTraceServer = createApiTraceServer();
	}

	return maybeApiTraceServer;
}
